import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=b06b6f1e&scoped=true&"
import script from "./Brand.vue?vue&type=script&lang=js&"
export * from "./Brand.vue?vue&type=script&lang=js&"
import style0 from "./Brand.vue?vue&type=style&index=0&id=b06b6f1e&prod&lang=scss&"
import style1 from "./Brand.vue?vue&type=style&index=1&id=b06b6f1e&prod&lang=scss&scoped=true&"
import style2 from "./Brand.vue?vue&type=style&index=2&id=b06b6f1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06b6f1e",
  null
  
)

export default component.exports